// @ts-check

/**
 * Takes an SSN masked value with formatting (like from a mask),
 * such as XXX-XX-1234, and returns just the numerals like 1234
 * in the SSN, which can be useful for storing in
 * redux, or submitting to API.
 *
 * @param {string?} value
 */
export const normalizeLast4SSN = (value) => {
  if (!value) {
    return value;
  }

  return value.replace(/[^\d]/g, '');
};
